import { UpdateInfoScreen } from "src/screens/auth/UpdateInfoScreen";
import { LoginScreen } from "../screens/auth/LoginScreen";
import { RegisterScreen } from "../screens/auth/RegisterScreen";
import { TermScreen } from "../screens/auth/TermScreen";
import { VerificationScreen } from "../screens/auth/VerificationScreen";
import { ForgetScreen } from "src/screens/auth/ForgetScreen";
import { AgreementScreen } from "src/screens/auth/AgreementScreen";

export const AuthRoutes = [
  { path: "/", exact: true, component: LoginScreen },
  { path: "/signup", exact: true, component: RegisterScreen },
  { path: "/update/seller", exact: true, component: UpdateInfoScreen },
  { path: "/signup/termsandagreement", exact: true, component: TermScreen },
  { path: "/verify", exact: true, component: VerificationScreen },
  { path: "/forget", exact: true, component: ForgetScreen },
  { path: "/merchant/agreement", exact: true, component: AgreementScreen },
];
